import React, { useMemo } from 'react';
import { TickMarkOutlined } from '@duxton-web/icons';
import { Table, Tabs, Typography } from '@duxton-web/ui';
import { ColumnProps } from '@duxton-web/ui/lib/table';

import {
  buildPermissionMatrixRows,
  getPermissionMatrixTabs,
  PermissionMatrixRow,
} from './utils';
import { useUserRolesContext } from '@/contexts/UserRolesContext';

const renderAllowedMark = (allowed: boolean) =>
  allowed ? (
    <span aria-label="Checked" className="access-control-check">
      <TickMarkOutlined />
    </span>
  ) : (
    <span aria-label="No access" className="access-control-empty">
      -
    </span>
  );

const matrixColumns: ColumnProps<PermissionMatrixRow>[] = [
  {
    title: 'Action',
    dataIndex: 'actionLabel',
    key: 'actionLabel',
    render: (text: string) => <Typography.Text>{text}</Typography.Text>,
  },
  {
    title: 'Allowed',
    dataIndex: 'allowed',
    key: 'allowed',
    align: 'center',
    width: 120,
    render: renderAllowedMark,
  },
];

export const PermissionMatrix = () => {
  const { enableServiceAuthZ, userRoles, userTFRoles } = useUserRolesContext();
  const tabs = useMemo(() => getPermissionMatrixTabs(), []);
  const tabItems = useMemo(
    () =>
      tabs.map((tab) => ({
        key: tab.key,
        label: tab.label,
        children: (
          <Table
            size="middle"
            className="grab-x__table"
            columns={matrixColumns}
            dataSource={buildPermissionMatrixRows(
              tab,
              userTFRoles,
              userRoles,
              enableServiceAuthZ,
            )}
            pagination={false}
          />
        ),
      })),
    [enableServiceAuthZ, tabs, userRoles, userTFRoles],
  );

  return (
    <div className="access-control-card-content">
      <Tabs defaultActiveKey={tabs[0]?.key} size="small" items={tabItems} />
    </div>
  );
};

export default PermissionMatrix;
